import { render, staticRenderFns } from "./estrattiConto.vue?vue&type=template&id=4096baa2&"
import script from "./estrattiConto.vue.ts?vue&type=script&lang=ts&"
export * from "./estrattiConto.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports